import React, { useState, useEffect, useContext } from "react";
import {
  dayCodeToDate,
  currentDayCode,
  getBarColor,
  getGoalLineHeight,
  getBarHeight,
} from "../../Utility";
import { Context } from "../../Store";
import DataService from "../../DataService";
import ClipLoader from "../loaders/ClipLoader";
import PubSub from "pubsub-js";
import $ from "jquery";
import { minBy, maxBy, findIndex, take } from "lodash-es";
import I18n from "../../Translation";

export default function CaloriesCard() {
  const [state, dispatch] = useContext(Context);
  const [allCalories, setAllCalories] = useState([]);
  let lastItemCode = allCalories.length
    ? minBy(allCalories, "dayCode").dayCode
    : currentDayCode() + 1;
  const [currentItem, setCurrentItem] = useState({ index: 0 });
  const [loading, setLoading] = useState(false);
  const [makingRequest, setMakingRequest] = useState(false);
  const [initialScroll, setInitialScroll] = useState(false);
  const [maxReading, setMaxReading] = useState(0); // highest calorie count in the viewport
  const [inViewport, setInViewport] = useState([]); // array of calorie counts in the viewport
  const [goalHeight, setGoalHeight] = useState(null); // goal indicator bottom position in pixels
  const [isActive, setIsActive] = useState(true); // scroll container touch event state
  let allGoals = "normal";
  let scrollFix = $("body").hasClass("ios-scroll-fix");
  let emptyCalorieHistory = null;
  if (
    !DataService.userDailySummaries.length &&
    DataService.minDaySteps === currentDayCode()
  ) {
    emptyCalorieHistory = true;
  }

  useEffect(() => {
    if (scrollFix) {
      $(".calories-card .scroll-container").scrollLeft(-790);
      setTimeout(() => {
        setInitialScroll(true);
      }, 10);
    }
    let token = PubSub.subscribe("daycodechanged", function (msg, data) {
      DataService.getCalories(data.dayCode, data.dayCode).then((records) => {
        // State is stale, so use setter to access current state
        setAllCalories((prevCalories) => {
          let newCalories = [...prevCalories];
          let index = findIndex(newCalories, { dayCode: records[0].dayCode });
          if (index >= 0) {
            newCalories[index] = records[0];
          }
          return newCalories;
        });
      });
    });
    return function cleanup() {
      console.log(`CaloriesCard[unsubscribe] token: ${token}`);
      PubSub.unsubscribe(token);
    };
  }, []);

  // detect changes in scrolling and set the current item
  const scrollEvent = () => {
    let graphItems = $(".calories-card .graph-item");
    graphItems.each((index, item) => {
      let graphItemX = item.getBoundingClientRect().x;
      let math = $(window).width() / graphItemX;
      let string = math.toString().slice(0, 3);
      if (string === "2.0") {
        setCurrentItem((currentItem) => {
          return {
            ...currentItem,
            index: index,
          };
        });
      }
    });
  };

  // older ios versions don't respect RTL and snap.  This jquery prevents over-scrolling.
  $(document).ready(() => {
    if (scrollFix) {
      // overscroll to the left
      let scrollEdge = $(".calories-card .scroll-container").scrollLeft();
      if (scrollEdge === 0 || scrollEdge === 1) {
        $(".calories-card .scroll-container").scrollLeft(-10);
      }
      // overscroll to the right
      $(".calories-card .scroll-container").on("scroll", function () {
        if (initialScroll) {
          let firstItem = $(".calories-card .graph-item").first();
          if (firstItem[0].getBoundingClientRect().x < 170) {
            $(".calories-card .scroll-container").css("overflow-x", "hidden");
            setTimeout(() => {
              $(".calories-card .scroll-container").css("overflow-x", "scroll");
            }, 50);
          }
        }
      });
    }
  });

  useEffect(() => {
    if (lastItemCode) {
      if (
        allCalories[currentItem.index]?.dayCode < lastItemCode + 2 ||
        currentDayCode() + 1 === lastItemCode
      ) {
        if (!makingRequest && !loading) {
          setMakingRequest(true);
          setLoading(true);
          DataService.getCalories(lastItemCode - 20, lastItemCode - 1).then(
            (newCalories) => {
              let concatCalories = [...allCalories, ...newCalories];
              if (!inViewport.length) {
                let max = maxBy(
                  take(concatCalories, 12),
                  "totalCalories"
                ).totalCalories;
                setMaxReading(max);
                setGoalHeight(
                  getGoalLineHeight(
                    max,
                    setMaxReading,
                    state.targetGoals.daily_calories,
                    "calories",
                    10000
                  )
                );
              }
              // this setTimeout ensures users will see a loading animation, and new bars will render in an organized fashion
              setTimeout(() => {
                setAllCalories(concatCalories);
                setLoading(false);
                setMakingRequest(false);
              }, 400);
            }
          );
        }
      }
    }
  }, [currentItem]);

  if (allCalories.length) {
    let metGoalCount = 0;
    let failedGoalCount = 0;
    allCalories.forEach((calorie) => {
      if (calorie.totalCalories >= state.targetGoals.daily_calories) {
        metGoalCount++;
      } else if (calorie.totalCalories < state.targetGoals.daily_calories) {
        failedGoalCount++;
      }
    });
    if (metGoalCount === allCalories.length) {
      allGoals = "pass";
    }
    if (failedGoalCount === allCalories.length) {
      allGoals = "fail";
    }
  }

  let currentCalorie = allCalories.length
    ? allCalories[currentItem.index]
    : { dayCode: currentDayCode() };

  $.fn.scrollEnd = function (callback, timeout) {
    $(this).on("scroll", function () {
      let $this = $(this);
      if ($this.data("scrollTimeout")) {
        clearTimeout($this.data("scrollTimeout"));
      }
      $this.data("scrollTimeout", setTimeout(callback, timeout));
    });
  };

  $.fn.isInViewport = function (rect) {
    if (rect.x > -5 && rect.x < $(window).width()) {
      return true;
    }
  };

  $(document).ready(() => {
    // if scrolling has come to an end, and the touch event is not active
    // calculate the items in the viewport and scale based on the max value
    $(".calories-card .scroll-container").scrollEnd(function () {
      if (!makingRequest && !loading && !isActive) {
        let items = $(".calories-card .graph-item");
        let list = [];
        items.each(function (index, item) {
          if ($(this).isInViewport(item.getBoundingClientRect())) {
            list.push({ total: $(this).data("calorie-total") });
          }
        });
        setInViewport(list);
        let max = maxBy(list, "total").total;
        setMaxReading(max);
        setGoalHeight(
          getGoalLineHeight(
            max,
            setMaxReading,
            state.targetGoals.daily_calories,
            "calories",
            10000
          )
        );
      }
    }, 300);
  });

  if (emptyCalorieHistory) {
    return (
      <div className="calories-card card-body">
        <div className="p-4 empty-description">
          {I18n.t(
            "javascript.statistics.statistics_page.empty_calories_description"
          )}
        </div>
      </div>
    );
  }
  return (
    <div className="calories-card card-body">
      <div className="loading-spinner">{loading && <ClipLoader />}</div>
      <div className="card-top-info">
        <div className="date">
          {dayCodeToDate(currentCalorie.dayCode, true)}
        </div>
        <div className="data-wrapper">
          <div className="data-description-left">
            <div className="count">{currentCalorie.inWorkoutCalories}</div>
            <div className="help-text">
              {I18n.t("javascript.statistics.statistics_page.in_workout")}
            </div>
          </div>
          <div className="vertical-rule" />
          <div className="data-description-right">
            <div className="count">
              {currentCalorie.totalCalories && currentCalorie.totalCalories}
            </div>
            <div className="help-text">
              {I18n.t("javascript.statistics.statistics_page.total")}
            </div>
          </div>
        </div>

        <div className="arrow-line">
          <div className="bottom-arrow" />
        </div>
      </div>
      {state.targetGoals.daily_calories > 0 && allCalories.length > 0 && (
        <div
          className="goal-indicators"
          style={{ bottom: "-" + goalHeight + "px" }}
        >
          <div className="dashed-line"></div>
          <div className="target-metric-wrapper">
            <div className="target-metric">
              {state.targetGoals.daily_calories}
            </div>
          </div>
        </div>
      )}
      <div
        onScroll={() => scrollEvent()}
        className="scroll-container"
        onTouchStart={() => setIsActive(true)}
        onTouchEnd={() => setIsActive(false)}
      >
        <div className="offset">
          <div className="graph-item-container">
            {(allCalories.length > 0 ? allCalories : [currentCalorie]).map(
              (obj, index) => {
                const style = getBarColor(
                  obj.totalCalories,
                  state.targetGoals.daily_calories
                );
                const totalHeight = getBarHeight(
                  obj.totalCalories,
                  maxReading,
                  setMaxReading,
                  state.targetGoals.daily_calories,
                  "calories",
                  10000
                );
                const inWorkoutHeight = getBarHeight(
                  obj.inWorkoutCalories,
                  maxReading,
                  setMaxReading,
                  state.targetGoals.daily_calories,
                  "calories",
                  10000
                );
                return (
                  <div
                    style={{
                      height: totalHeight.height + "px",
                      backgroundColor: style.totalColor,
                    }}
                    key={index}
                    className="graph-item snap-align-center"
                    data-calorie-total={obj.totalCalories}
                  >
                    {obj.inWorkoutCalories > 0 && (
                      <div className="graph-item-overlay">
                        <div
                          style={{
                            height: inWorkoutHeight.height + "px",
                            backgroundColor: style.inWorkoutColor,
                          }}
                          className="in-workout"
                        />
                      </div>
                    )}
                  </div>
                );
              }
            )}
          </div>
        </div>
      </div>
      {state.targetGoals.daily_calories > 0 && (
        <div className="legend-container">
          <div className={`legend in-workout-${allGoals}`} />
          <div className="legend-text">
            {I18n.t("javascript.statistics.statistics_page.in_workout")}
          </div>
          <div className={`legend total-${allGoals}`} />
          <div className="legend-text">
            {I18n.t("javascript.statistics.statistics_page.total_calories")}
          </div>
        </div>
      )}
    </div>
  );
}
